import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LineChart } from "@mui/x-charts";
import { format } from "date-fns";
import ResponsiveCharts from "../ChartsLayout/ResponsiveCharts.jsx";
import CustomGridItem from "../ChartsLayout/CustomGridItem.jsx";

const RISK_LABELS = {
  1: "Very Low",
  2: "Low",
  3: "Medium",
  4: "High",
  5: "Very High",
};

export default function RiskLevel({ riskHistory }) {
  const { t } = useTranslation("statistics");
  const hasData = riskHistory.length > 0;

  const dates = riskHistory.map((r) =>
    format(new Date(r.created_at), "dd/MM/yyyy")
  );
  const levels = riskHistory.map((r) => r.final_risk_level);

  return (
    <ResponsiveCharts>
      {({ chartWidth }) => (
        <CustomGridItem>
          <Typography
            sx={{
              margin: {
                xs: "20px 0",
                sm: "20px 0",
                md: "0 0 20px 0",
                lg: "20px 0 0 20px",
                xl: "20px",
              },
              textAlign: "center",
            }}
            variant="h6"
          >
            {t("charts.risk.riskTitle")}
          </Typography>
          {hasData ? (
            <LineChart
              xAxis={[
                {
                  scaleType: "band",
                  data: dates,
                  label: t("charts.risk.dateLabel"),
                },
              ]}
              yAxis={[
                {
                  min: 0,
                  max: 5,
                  tickMinStep: 1,
                  valueFormatter: (value) => RISK_LABELS[value] || "",
                },
              ]}
              series={[
                {
                  data: levels,
                  label: t("series.riskLevel"),
                  color: "#186480",
                  area: true,
                },
              ]}
              width={chartWidth}
              height={300}
              margin={{ left: 80 }}
            />
          ) : (
            <Typography sx={{ textAlign: "center", mt: 2, mb: 4 }}>
              {t("empty.noData")}
            </Typography>
          )}
        </CustomGridItem>
      )}
    </ResponsiveCharts>
  );
}
